import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExpedienteService } from 'src/app/services/expediente.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'exploracion',
  templateUrl: './exploracion.component.html',
})

export class ExploracionComponent {

  formExp: FormGroup;

  @Input() public id_paciente = null;

  public datos_exp = {
    "id_paciente" : "",
    "lengua" : "",
    "oclusion" : "",
    "labios" : "",
    "carrillos" : "",
    "pisoboca" : "",
    "ganglios" : "",
    "vestibulo" : "",
    "atm" : "",
    "paladar" : "",
    "musculos" : "",
  };

  constructor(
    private spinner: NgxSpinnerService,
    private _bilder: FormBuilder,
    private _expedienteService: ExpedienteService,
  ){

  }

  ngOnInit(){
    this.colocarValores();
    this.obtenerExp();
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  colocarValores( exp = null ){
    let datos = null;
    if( exp != null ){
      datos = exp;
    }else{
      datos = this.datos_exp;
      datos.id_paciente = this.id_paciente;
    }

    this.formExp = this._bilder.group({
      id_paciente : [datos.id_paciente],
      lengua: [datos.lengua],
      oclusion: [ datos.oclusion ],
      labios: [ datos.labios],
      carrillos: [ datos.carrillos ],
      pisoboca: [ datos.pisoboca ],
      ganglios: [ datos.ganglios ],
      vestibulo: [ datos.vestibulo ],
      atm: [ datos.atm ],
      paladar: [ datos.paladar ],
      musculos: [ datos.musculos ],
    });
  }

  obtenerExp(){
    this.spinner.show('spnr-s');
    if( this.id_paciente != null){
      let respuesta = this._expedienteService.obtenerExp( this.id_paciente );
      respuesta.then(
        val =>{
          if( val.status == "success" ){
            this.spinner.hide('spnr-s');
            if( val.exploracion != null ){
              this.colocarValores( val.exploracion );
            }
          }else{
            this.spinner.hide('spnr-s');
            Swal.fire({
              title: 'Oopss...',
              text: val.message,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#1beb11',
            });
          }
        },
        error =>{
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: 'Oopss...',
            text: 'Ha ocurrido un problema al cargar los datos, se recomienda recargar la pagina.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });
        }
      );
    }else{
      this.spinner.hide('spnr-s');
      Swal.fire({
        title: 'Oopss...',
        text: 'Ha ocurrido un problema al cargar los datos, se recomienda recargar la pagina.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#1beb11',
      });
    }
  }

  registrarExp( datos ){
    this.spinner.show('spnr-s');
    let respuesta = this._expedienteService.registrarExp( datos );
    respuesta.then(
      val =>{
        if( val.status == "success" ){
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: "Registro Exitoso",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });
        }else{
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: 'Oopss...',
            text: val.message,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });

        }
      },
      error =>{
        this.spinner.hide('spnr-s');
        Swal.fire({
          title: 'Oopss...',
          text: "Ha ocurrido un problema al registrar los datos, por favor intentalo nuevamente.",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#1beb11',
        });
      }
    );

  }

}
